import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ApiMaintenanceService } from '../maintenance.service';

export const apiMaintenanceGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const apiMaintenanceSrv = inject(ApiMaintenanceService);
  apiMaintenanceSrv.run();
  return apiMaintenanceSrv.updates.pipe(
    map(() => {
      console.log('result');
      if (!apiMaintenanceSrv.enabled) {
        router.navigate(['/']);
        return false;
      } else {
        return true;
      }
    }),
  );
};
